import axios from 'axios';
import PDFMerger from 'pdf-merger-js/browser';
import { setHttpTurnHttps } from '@/utils/tools';

const getFile = (url, forceRefresh = false) => {
  if (forceRefresh) {
    return fetch(url, { cache: 'reload' }).then(response => {
      if (!response.ok) throw new Error(`Label download failed: ${response.status}`);
      return response.blob();
    });
  }
  return new Promise((resolve, reject) => {
    const obj = {
      method: 'get',
      url,
      responseType: 'blob'
      // responseType: 'arraybuffer'
    };
    axios(obj).then(data => {
      // console.log(data);
      resolve(data.data);
    }).catch(error => {
      // console.log(1);
      reject(error.toString());
    });
  });
};

/**
 * 批量现在
 */
const batchPdfDownload = async(arr, { forceRefresh = false } = {}) => {
  try {
    const promisePDFUrlArr = arr.map((item) => {
      // 将 http 升级到 https
      const newURl = setHttpTurnHttps(item);
      return getFile(newURl, forceRefresh);
    });
    const merger = new PDFMerger();

    const resultsArr = await Promise.allSettled(promisePDFUrlArr);
    if (forceRefresh && resultsArr.some(item => item.status === 'rejected')) {
      throw new Error('Label download failed');
    }
    // 过滤出成功的请求
    const successfulPromises = resultsArr.filter(item => {
      return item.status === 'fulfilled';
    });
    for (const { value } of successfulPromises) {
      await merger.add(value);
    }
    const mergedPdf = await merger.saveAsBlob();
    const strURl = await promiseFileReader(mergedPdf);
    return strURl;
  } catch (error) {
    if (forceRefresh) throw error;
    console.error(error);
    return '';
  }
};

const promiseFileReader = (blorStr) => {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.readAsDataURL(blorStr);
    reader.onload = function() {
      // var dataURL = reader.result;
      res(reader.result);
    };
    reader.onerror = function(e) {
      // var dataURL = reader.result;
      rej(e);
    };
  });
};

export {
  // creationBlob
  batchPdfDownload
};

